import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

const DEFAULTS = {
  company_name: "Dreamzz HR & Consultancy",
  tagline: "Connecting the Right Talent With the Right Opportunity",
  phone: "+91 63640 40932",
  whatsapp: "916364040932",
  email: "dreamzzckmhr@gmail.com",
  address: "Mallandur Road, Chikkamagaluru, Karnataka 577101",
  instagram: "https://www.instagram.com/dreamzz_career",
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings");
        if (data && data.company_name) setSettings({ ...DEFAULTS, ...data });
      } catch (e) {}
    })();
  }, []);

  return <SiteContext.Provider value={{ settings, setSettings }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext) || { settings: DEFAULTS };

export function waLink(number, message) {
  const num = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message || "")}`;
}
